import { canNavigate, getDefaultRoute } from '@/services/auth.service'
import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import academy from './academy'
import agency from './agency'
import ai from './ai'
import club from './club'
import community from './community'
import dashboard from './dashboard'
import jobs from './jobs/'
import network from './network'
import observatory from './observatory'
import services from './services'
import shop from './shop'
import token from './token/'
import tv from './tv/'
import gamification from './gamification/'
import meetings from './meetings'
import referrals from './referrals'
import ventures from './ventures'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalReplace.call(this, location).catch(err => err)
}

const withVertical = (routeArr, vertical) => routeArr.map(route => ({
	...route,
	meta: { ...route.meta, vertical },
}))

const routes = [
	{
		path: '/',
		redirect: () => {
			return { name: getDefaultRoute() }
		},
	},
	{
		path: '/error-404',
		name: 'error-404',
		component: () => import('@/views/Error404.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
		},
	},
	{
		path: '/error-403',
		name: 'error-403',
		component: () => import('@/views/Error403.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
		},
	},
	{
		path: '/login',
		name: 'auth-login',
		component: () => import('@/views/Login.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
			redirectIfLoggedIn: true,
		},
	},
	{
		path: process.env.VUE_APP_ACCOUNTS_URL + '/logout',
		name: 'auth-logout',
        beforeEnter() {
            window.location.href = process.env.VUE_APP_ACCOUNTS_URL + '/logout' // Redireciona para link externo
        }
	},
	{
		path: '/register',
		name: 'auth-register',
		component: () => import('@/views/Register.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
			redirectIfLoggedIn: true,
		},
	},
	{
		path: '/forgot-password',
		name: 'auth-forgot-password',
		component: () => import('@/views/ForgotPassword.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
			redirectIfLoggedIn: true,
		},
	},
	// {
	// 	path: '/mundo-gamer-messages',
	// 	name: 'mg-platforms-messages',
	// 	component: () => import('@/views/messages/PlatformsMessages.vue'),
	// 	props: true,
	// 	meta: {
	// 		layout: 'content',
	// 	},
	// },
	{
		path: '/mundo-gamer-platforms/messages',
		name: 'mg-platforms-messages',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,messages',
		},
	},
	{
		path: '/mundo-gamer-messages/:context',
		name: 'mundo-gamer-messages',
		component: () => import('@/views/messages/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,messages',
		},
	},
	{
		path: '/mundo-gamer-platforms/newsletters',
		name: 'mg-platforms-newsletters',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,newsletter',
		},
	},
	{
		path: '/mundo-gamer-newsletters/:context',
		name: 'mundo-gamer-newsletters',
		component: () => import('@/views/newsletters/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,newsletter',
		},
	},
	{
		path: '/mundo-gamer-platforms/notifications',
		name: 'mg-platforms-notifications',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,notifications',
		},
	},
	{
		path: '/mundo-gamer-notifications/:context',
		name: 'mundo-gamer-notifications',
		component: () => import('@/views/notifications/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,notifications',
		},
	},
	{
		path: '/notification-suggestions',
		name: 'notification-suggestions',
		component: () => import('@/views/notifications/suggestions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,notifications',
		},
	},
	{
		path: '/commissions',
		name: 'commissions-dashboard',
		component: () => import('@/views/commissions/dashboard.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/partner/commissions/:token',
		name: 'partner-commissions',
		component: () => import('@/views/commissions/partner.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
		},
	},
	// The video editor's running order. Public by token on purpose: they work
	// four times a year and the showcase-production grant does not open any
	// admin route today. Rotating the token in the admin revokes the link.
	{
		path: '/showcase-rundown/:token',
		name: 'showcase-rundown-public',
		component: () => import('@/views/showcase-rundown/public.vue'),
		meta: {
			layout: 'blank',
			resource: 'Public',
		},
	},
	{
		path: '/mundo-gamer-platforms/faqs',
		name: 'mg-platforms-faqs',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-faqs/:context',
		name: 'mundo-gamer-faqs',
		component: () => import('@/views/network/network-systems/faqs/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-platforms/roles',
		name: 'mg-platforms-roles',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-roles/:context',
		name: 'mundo-gamer-roles',
		component: () => import('@/views/network/network-systems/acl/roles/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-platforms/permissions',
		name: 'mg-platforms-permissions',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-permissions/:context',
		name: 'mundo-gamer-permissions',
		component: () => import('@/views/network/network-systems/acl/permissions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/mundo-gamer-platforms/modules',
		name: 'mg-platforms-modules',
		component: () => import('@/views/MGPlatforms.vue'),
		props: true,
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
			roles: ['MGN,admin'],
		},
	},
	{
		path: '/mundo-gamer-modules/:context',
		name: 'mundo-gamer-modules',
		component: () => import('@/views/network/network-systems/acl/modules/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
			roles: ['MGN,admin'],
		},
	},
	...withVertical(dashboard, 'network'),
	...withVertical(services, 'network'),
	...withVertical(network, 'network'),
	// 'network' e nao 'observatory': o Observatorio nao tem linha em mg_network_systems
	// (adiada de proposito ate o nome do produto estar decidido), e conceder acesso a
	// cliente dele e administracao da rede — mesmo caso de gamification e referrals.
	...withVertical(observatory, 'network'),
	...withVertical(academy, 'academy'),
	...withVertical(ai, 'ai'),
	...withVertical(community, 'community'),
	...withVertical(agency, 'agency'),
	...withVertical(jobs, 'jobs'),
	...withVertical(shop, 'shop'),
	...withVertical(club, 'club'),
	...withVertical(token, 'token'),
	...withVertical(tv, 'tv'),
	...withVertical(gamification, 'network'),
	...withVertical(meetings, 'network'),
	...withVertical(referrals, 'network'),
	...withVertical(ventures, 'ventures'),
	{
		path: '*',
		redirect: 'error-404',
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return {
			x: 0,
			y: 0,
		}
	},
})

// Tracks the fullPath of whatever navigation is currently in flight, so a
// chunk-load failure (see router.onError below) knows where the user was
// actually trying to go, not just where they reload back to.
let pendingNavigationPath = null

// ? Router Before Each hook: https://router.vuejs.org/guide/advanced/navigation-guards.html
/**
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
router.beforeEach((to, from, next) => {
	pendingNavigationPath = to.fullPath

	// Public routes bypass ACL checks
	if (to.meta.resource === 'Public') {
		return next()
	}

	// Check roles + module access
	if (canNavigate(to.meta.roles, router.app, to.meta.module)) {
		return next()
	}

	// Prevent infinite redirect loop to error-403
	if (to.name === 'error-403') {
		return next()
	}

	return next({ name: 'error-403' })
})

// Lazy-loaded route chunks reference a build hash baked in at compile time.
// When the dev/CI build rebuilds while the app is already open in the
// browser, that hash goes stale and any navigation to a not-yet-visited
// route throws "Loading chunk ... failed" — the app looks stuck until the
// user manually hits F5. Worse, because the failed async-component resolve
// aborts before vue-router updates history, the URL (and the page you see
// after the auto-reload below) silently falls back to the *previous* route,
// not the one that was actually clicked — e.g. clicking "Edit" bounces you
// back to the list with no error, which reads as "I lost access to Edit".
// Auto-reload once instead of leaving it stuck, and stash the route that
// was actually being navigated to so it can be resumed after the reload
// (see the post-mount check in main.js). Guard with sessionStorage so a
// genuinely broken chunk doesn't reload-loop.
router.onError((error) => {
	const isChunkLoadError = /Loading( CSS)? chunk .+ failed/.test(error.message)
	if (!isChunkLoadError) return

	if (!sessionStorage.getItem('chunk_load_retry')) {
		sessionStorage.setItem('chunk_load_retry', '1')
		if (pendingNavigationPath) {
			sessionStorage.setItem('chunk_load_redirect', pendingNavigationPath)
		}
		window.location.reload()
	}
})

router.afterEach(() => {
	sessionStorage.removeItem('chunk_load_retry')
})

export default router
